jQuery(function( $ ) {
    // Thanks to Mark Avery
    // http://stackoverflow.com/questions/8191015/how-do-i-lay-out-my-content-divs-in-a-similar-manner-to-facebook-timeline
    var adjustArticleHeights = (function () {

        var leftColumnHeight = 0,
            rightColumnHeight = 0,
            $articles = $('.teaser-list .teaser');

        for (var i = 0; i < $articles.length; i++) {
            // This just adds random heights to articles
            // $articles.eq(i).height(Math.floor(Math.random() * 300) + 10);

            if (leftColumnHeight > rightColumnHeight) {
                rightColumnHeight += $articles.eq(i).addClass('right').outerHeight(true);
            } else {
                leftColumnHeight += $articles.eq(i).outerHeight(true);
            }
        }

        return $articles;
    })();
});